module.exports = __webpack_public_path__ + "cloud-text-example.png?68587bc062c71dd5d669704fac5897db";